// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2a61J","content":"styles_content__3-7Ec","selectAll":"styles_selectAll__28-tz"};